import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Chart from './chart';
import { XLine } from '../line';
import { Legend } from '../legend';
import { Annotation } from '../annotation';
import { linearTransform, formatNumber } from '../../utilities';
const MultiXLineChart = (props, ref) => {
    const domain = useMemo(() => ({
        x: props.xDomain,
        y: props.yDomain || {
            start: Math.min(...props.data.map((entry) => Math.min(...entry.data))),
            end: Math.max(...props.data.map((entry) => Math.max(...entry.data)))
        }
    }), [props]);
    const reverseTransform = useMemo(() => linearTransform(domain.x, { start: 0, end: props.data[0].data.length - 1 }), [domain, props.data]);
    const transform = useMemo(() => linearTransform({ start: 0, end: props.data[0].data.length - 1 }, domain.x), [domain, props.data]);
    const [mouseLocation, setMouseLocation] = useState(null);
    const onMouseMove = useCallback((e, location, dataLocation) => {
        setMouseLocation({
            mouseLocation: location,
            mouseDataLocation: dataLocation
        });
    }, []);
    const onMouseOut = useCallback(() => setMouseLocation(null), []);
    const index = useMemo(() => mouseLocation ? Math.round(reverseTransform(mouseLocation.mouseDataLocation.x)) : 0, [mouseLocation]);
    useEffect(() => {
        if (props.data.length === 0)
            return;
        const length = props.data[0].data.length;
        for (let i = 1; i < props.data.length; ++i)
            if (props.data[i].data.length !== length)
                throw new Error("All entries of a MultiXLineChart must have the same length.");
    }, [props]);
    const { data, xAxisProps, yAxisProps, plotAreaProps } = props;
    const plotAreaPropsS = useMemo(() => (Object.assign({ onMouseMove,
        onMouseOut, withGuideLines: true, guideLineProps: {
            hideHorizontal: true,
            hideVertical: true
        } }, (plotAreaProps || {}))), [plotAreaProps]);
    const width = props.innerSize.width / 3;
    const height = props.innerSize.height / 20;
    const mx = (mouseLocation === null || mouseLocation === void 0 ? void 0 : mouseLocation.mouseLocation.x) || 0, my = (mouseLocation === null || mouseLocation === void 0 ? void 0 : mouseLocation.mouseLocation.y) || 0;
    const x = mx + width > props.innerSize.width * 2 / 3 ? (mx - width * (1 + 1 / 30)) : mx + props.innerSize.width / 30;
    const y = my + height * (props.data.length + 1.1) > props.innerSize.height ? (my - height * (data.length + 1.1)) : my;
    const format = (props.legendProps && props.legendProps.headerProps && props.legendProps.headerProps.numberFormat) || formatNumber;
    return (React.createElement(Chart, Object.assign({}, props, { plotAreaProps: plotAreaPropsS, domain: domain, xAxisProps: xAxisProps, yAxisProps: yAxisProps, ref: ref }),
        data.map((entry, i) => (React.createElement(XLine, Object.assign({ domain: domain, data: entry.data, stroke: entry.color, key: i }, props.lineProps)))),
        mouseLocation && (React.createElement("line", { x1: transform(index), x2: transform(index), y1: domain.y.start, y2: domain.y.end, stroke: "#888888", strokeWidth: "1px", vectorEffect: "non-scaling-stroke", shapeRendering: "crispEdges" })),
        mouseLocation && (React.createElement(Annotation, { x: x, y: y, notScaled: true, notTranslated: true },
            React.createElement(Legend, Object.assign({ title: format(transform(index)), size: { width, height: height * data.length }, entries: data.map((entry) => ({
                    label: entry.label,
                    color: entry.color,
                    value: formatNumber(entry.data[index])
                })) }, (props.legendProps || {}))))),
        props.children));
};
export default React.forwardRef(MultiXLineChart);
